import { render } from "./SalesPersonCreateProfile.vue?vue&type=template&id=0009c55b&scoped=true&ts=true&lang=pug"
import script from "./SalesPersonCreateProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./SalesPersonCreateProfile.vue?vue&type=script&lang=ts&setup=true"

import "./SalesPersonCreateProfile.vue?vue&type=style&index=0&id=0009c55b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0009c55b"]])

export default __exports__